module.exports = __webpack_public_path__ + "static/media/tonight.84412285.png";